module.exports = {
  appId: 'f58c8ea75e424080af8f8ec2e19e380c',
  requestAppId: 'envirodata-app',
  getItem (key) {
    return localStorage.getItem(this.appId + '_' + key)
  },
  setItem (key, value) {
    localStorage.setItem(this.appId + '_' + key, value)
  },
  removeItem (key) {
    localStorage.removeItem(this.appId + '_' + key)
  },
  clear() {
    let prefix = this.appId + '_'
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith(prefix)) {
        localStorage.removeItem(key)
            // Decrement counter since we removed an item
        i--
      }
    }
  },
}



